import { MapPin, Navigation } from 'lucide-react';

/**
 * LocationBubble — improved chat location share.
 * Renders an OpenStreetMap static tile preview (free, no key) above the
 * place name. Tapping opens the location in Google Maps.
 */
export default function LocationBubble({ location, isMine }) {
  if (!location || typeof location.lat !== 'number' || typeof location.lng !== 'number') return null;
  const { lat, lng } = location;
  // OSM static map (free, key-less). 260×130 tile centered on the point.
  const mapUrl = `https://staticmap.openstreetmap.de/staticmap.php?center=${lat},${lng}&zoom=15&size=260x130&markers=${lat},${lng},red-pushpin`;
  const gmapsUrl = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;

  return (
    <a
      href={gmapsUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      className="block rounded-2xl overflow-hidden mb-1 w-[260px] max-w-full bg-white border border-black/[0.06] shadow-sm"
      data-testid="msg-location"
    >
      <div className={`relative h-[130px] w-full ${isMine ? 'bg-[#3F5200]/10' : 'bg-[#F1F0EA]'}`}>
        <img
          src={mapUrl}
          alt=""
          className="w-full h-full object-cover"
          loading="lazy"
          onError={(e) => { e.currentTarget.style.display = 'none'; }}
        />
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <div className="w-9 h-9 rounded-full bg-[#FF3B30] flex items-center justify-center shadow-md ring-4 ring-white">
            <MapPin size={16} className="text-white" fill="currentColor" />
          </div>
        </div>
      </div>
      <div className="px-3 py-2 flex items-center justify-between gap-2">
        <div className="min-w-0 flex-1">
          <p className="text-xs font-bold text-[#111111] truncate">{location.name || 'Shared location'}</p>
          {location.address && (
            <p className="text-[10px] text-[#9B9EA3] truncate">{location.address}</p>
          )}
        </div>
        <div className="w-7 h-7 rounded-full bg-[#B6E600] flex items-center justify-center flex-shrink-0">
          <Navigation size={12} className="text-[#111111]" strokeWidth={2.5} />
        </div>
      </div>
    </a>
  );
}
